import React from 'react';
import { ChevronDown } from 'lucide-react';
import { ORDER_STATUS, ORDER_STATUS_LABELS, ORDER_STATUS_COLORS } from '../../utils/constants';

// Badge de statut interactif : garde le look coloré du StatusBadge mais permet
// de changer le statut au clic (liste déroulante native stylée en pilule).
const StatusSelect = ({ status, onChange, className = '' }) => {
    const colorClass = ORDER_STATUS_COLORS[status] || 'bg-gray-500/20 text-gray-300 border-white/20';
    const textClass = colorClass.split(' ').find((c) => c.startsWith('text-')) || 'text-gray-300';

    return (
        <div className={`relative inline-block ${className}`} onClick={(e) => e.stopPropagation()}>
            <select
                value={status}
                onChange={(e) => onChange(e.target.value)}
                title="Changer le statut"
                className={`appearance-none cursor-pointer rounded-full border pl-3 pr-8 py-1.5 text-xs font-medium
                    focus:outline-none focus:ring-2 focus:ring-yellow-500/50 hover:brightness-110 transition ${colorClass}`}
            >
                {Object.values(ORDER_STATUS).map((s) => (
                    <option key={s} value={s} style={{ backgroundColor: '#1f2937', color: '#fff' }}>
                        {ORDER_STATUS_LABELS[s]}
                    </option>
                ))}
            </select>
            <ChevronDown className={`pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 h-3.5 w-3.5 opacity-70 ${textClass}`} />
        </div>
    );
};

export default StatusSelect;
